import { EEstimationTargets } from '@cian/valuation-main-filters-widget';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useRunBeforePushSubscription } from './useRunBeforePushSubscription';
import { checkEstimationExists, checkEstimationForUser } from '../../../actions/checkEstimationExists';
import { openDataPaymentForm } from '../../../actions/dataPayment';
import { saveUserEstimation, submitValuationForm } from '../../../actions/submitValuationForm';
import { checkIsAgent } from '../../../actions/user';
import { selectCheckEstimationExists } from '../../../selectors/checkEstimationExists/selectCheckEstimationExists';
import { selectFilters } from '../../../selectors/selectFilters';
import { TThunkDispatch } from '../../../types/redux';

export function useHandleDatapaymentSubmit() {
  const dispatch = useDispatch<TThunkDispatch>();
  const { estimationId } = useSelector(selectCheckEstimationExists);
  const { pushEnabled, estimationTarget } = useSelector(selectFilters);

  const runBeforePushSubscription = useRunBeforePushSubscription();

  return React.useCallback(async () => {
    const redirectToDataPayment = async (pushNeed?: boolean) => {
      /** На этом месте после запроса авторизации юзер может быть залогинен,
       *  поэтому нужно получить нового юзера из стора.
       *  Если юзер залогинился как агент, то редирект к результатам
       *  */
      const isAgent = dispatch(checkIsAgent());

      if (isAgent) {
        await dispatch(saveUserEstimation({ pushNeed }));
        dispatch(submitValuationForm());
      } else {
        dispatch(openDataPaymentForm({ pushNeed }));
      }
    };

    const redirectToDataPaymentWithSubscription = async () => {
      /** Подписываем на оценку, если тоггл включен, только для квартир и загородки */
      let shouldSubscribe = Boolean(pushEnabled && estimationTarget !== EEstimationTargets.newbuilding);

      if (shouldSubscribe) {
        shouldSubscribe = await runBeforePushSubscription();
      }

      await redirectToDataPayment(shouldSubscribe);
    };

    /**
     * Если нет id оценки (мы еще не проверили, оценивал ли он), проверяем оценивал ли пользователь уже
     * заданный адрес, если не оценивал ведем на форму расплаты, если оценивал
     * покажем плашку "Кажется вы уже оценивали этот объект"
     * */
    if (!estimationId) {
      const isEstimationExists = await dispatch(checkEstimationExists());

      if (isEstimationExists) {
        const result = await dispatch(checkEstimationForUser());

        if (!result) {
          await redirectToDataPaymentWithSubscription();
        }
      }

      return;
    }

    /**
     * Если id оценки есть (мы уже успели проверить этот факт) - ведем сразу на форму расплаты
     * Кейс срабатывает, когда юзер игнорирует сообщение "Кажется, вы уже оценивали..." и повторно жмет на "Оценить"
     * */
    await redirectToDataPaymentWithSubscription();
  }, [dispatch, estimationId, estimationTarget, pushEnabled, runBeforePushSubscription]);
}
